module.exports = {
    FUNNEL_NAME: 'gig_page',
};
